// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { debugToolProperty } from '../../../../debug/store/debugToolSelector';

// Components
import DrawingEditorBoundingBoxDebugger from './DrawingEditorBoundingBoxDebugger';
import DrawingEditorPathPointsDebugger from './DrawingEditorPathPointsDebugger';
import DrawingEditorStrokePointsDebugger from './DrawingEditorStrokePointsDebugger';

// Constants
import { DEBUG_TOOLS } from '../../../../debug/store/debugToolConstants';

// Styles
import './DrawingEditorDebugger.scss';

const mapStateToProps = createStructuredSelector({
    debugShowPathBoundingBox: debugToolProperty(DEBUG_TOOLS.DRAWING, 'showPathBoundingBox'),
    debugShowPathPoints: debugToolProperty(DEBUG_TOOLS.DRAWING, 'showPathPoints'),
    debugShowStrokePoints: debugToolProperty(DEBUG_TOOLS.DRAWING, 'showStrokePoints'),
});

const DrawingEditorDebugger = (props) => {
    const { debugShowPathBoundingBox, debugShowPathPoints, debugShowStrokePoints } = props;

    return (
        <div className="DrawingEditorDebugger">
            {debugShowPathBoundingBox && <DrawingEditorBoundingBoxDebugger {...props} />}
            {debugShowPathPoints && <DrawingEditorPathPointsDebugger {...props} />}
            {debugShowStrokePoints && <DrawingEditorStrokePointsDebugger {...props} />}
        </div>
    );
};

DrawingEditorDebugger.propTypes = {
    debugShowPathBoundingBox: PropTypes.bool,
    debugShowPathPoints: PropTypes.bool,
    debugShowStrokePoints: PropTypes.bool,
};

export default connect(mapStateToProps)(DrawingEditorDebugger);
